export default function Benefits() {
  const benefits = [
    {
      title: 'Szybka Reakcja',
      description: 'Interwencja w ciągu 2 godzin od zgłoszenia. W sytuacjach awaryjnych liczy się każda minuta.'
    },
    {
      title: 'Profesjonalny Sprzęt',
      description: 'Wykorzystujemy najnowocześniejsze osuszacze i urządzenia diagnostyczne najwyższej klasy.'
    },
    {
      title: 'Doświadczony Zespół',
      description: 'Nasi specjaliści posiadają wieloletnie doświadczenie i niezbędne certyfikaty branżowe.'
    },
    {
      title: 'Kompleksowa Obsługa',
      description: 'Od diagnozy, przez osuszanie, aż po remont - wszystko załatwimy za Ciebie.'
    },
    {
      title: 'Gwarancja Jakości',
      description: 'Udzielamy gwarancji na wykonane usługi. Twoje zadowolenie jest naszym priorytetem.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          {/* Image */}
          <div className="lg:col-span-2">
            <div className="relative h-[600px] rounded-tr-3xl rounded-br-3xl overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20industrial%20dehumidifier%20machine%20in%20action%20inside%20modern%20residential%20room%2C%20water%20damage%20restoration%20equipment%2C%20construction%20site%20with%20renovation%20work%2C%20professional%20technician%20working%2C%20clean%20white%20walls%2C%20realistic%20photography%2C%20bright%20lighting%2C%20high-quality%20commercial%20equipment&width=800&height=1200&seq=benefits-img-001&orientation=portrait"
                alt="Profesjonalny osuszacz w akcji"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Content */}
          <div className="lg:col-span-3">
            <p className="text-blue-600 text-sm font-semibold uppercase tracking-wider mb-3">
              Dlaczego My?
            </p>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-12 leading-tight">
              Twój Partner w<br />
              Sytuacjach Kryzysowych
            </h2>

            <div className="space-y-6">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                    <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center">
                      <i className="ri-check-line text-white text-sm"></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">
                      {benefit.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <button 
              onClick={() => {
                const element = document.getElementById('about');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="mt-10 px-8 py-4 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-all inline-flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              Poznaj Nas Bliżej
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}